// ** Checks if an object is empty (returns boolean)

import { Theme } from 'react-select';

export const isObjEmpty = (obj: Record<string, unknown>) =>
  Object.keys(obj).length === 0;

// ** Returns K format from a number
export const kFormatter = (num: number) =>
  num > 999 ? `${(num / 1000).toFixed(1)}k` : num;

// ** Converts HTML to string
export const htmlToString = (html: string) =>
  html.replace(/<\/?[^>]+(>|$)/g, '');

/**
 * Checks if string arrays have same values, regardless of their order
 */
export const isEqualStringArray = (
  arr1: string[] | undefined,
  arr2: string[] | undefined
) => {
  if (!arr1 || !arr2) {
    return arr1 === arr2;
  }
  if (arr1.length !== arr2.length) {
    return false;
  }
  const sortedArr1 = arr1.sort();
  const sortedArr2 = arr2.sort();

  return sortedArr1.every((str, i) => str === sortedArr2[i]);
};

// ** React Select Theme Colors
export const selectThemeColors = (theme: Theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7180b71a', // for option hover bg-color
    primary: '#7180b7', // for selected option bg-color
    neutral10: '#7180b7', // for tags bg-color
    neutral20: '#d8d6de', // for input border-color
    neutral30: '#d8d6de', // for input hover border-color
  },
});
